<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->
<div class="qv-filters">
    <p-panel [toggleable]="true" #panelContainer (onAfterToggle)="onFilterToggle($event)" [collapsed]="filterCollpase">
        <p-header>
            <div class="p-helper-clearfix" (click)="toggleQueryView(panelContainer)">
                <span class="p-panel-title">Filters</span>
            </div>
        </p-header>
        <form [formGroup]="filtersForm" novalidate>
            <div formArrayName="filters">
                <p-tabView (onChange)="tabChange($event)" [activeIndex]="activeIndex">
                    <p-tabPanel header=" {{configData.queryViewLabel.locomotives}}">
                        <lms-query-view-filter-locomotives [group]="locoGroup" [tabIndex]='tabIndex' [commonopsPicklist]="commonopsPicklist" [tab]="tab" [yardLocalSelectedList]="yardLocalSelected" [locoFeaturesListSecond]="locoFeaturesListSecondList" [locoFeaturesListThird]="locoFeaturesListThirdList"></lms-query-view-filter-locomotives>
                    </p-tabPanel>
                    <p-tabPanel header=" {{configData.queryViewLabel.trains}}">
                        <lms-query-view-filter-trains [group]="trainGroup" [tabIndex]='tabIndex + 400' [minMaxGPSError]="minMaxGPSError" [minMaxError]="minMaxError" [commonopsPicklist]="commonopsPicklist" [tab]="tab"></lms-query-view-filter-trains>
                    </p-tabPanel>
                    <p-tabPanel header=" {{configData.queryViewLabel.geo}}">
                        <lms-query-view-filter-geo [group]="geoGroup" [tabIndex]='tabIndex + 800' [commonopsPicklist]="commonopsPicklist" [tab]="tab" [geoDescriptionList]="geoDescription"></lms-query-view-filter-geo>
                    </p-tabPanel>
                    <p-tabPanel header=" {{configData.queryViewLabel.commodity}}">
                        <lms-query-view-filter-commodity [group]="commodityGroup" [tabIndex]='tabIndex + 1200' [commonopsPicklist]="commonopsPicklist" [tab]="tab" [commodityError]="commodityError" (resetCommodityError)="resetCommodityError($event)" [selectedAll]="selectAllCommodity"></lms-query-view-filter-commodity>
                    </p-tabPanel>
                </p-tabView>

                <div class="dialog-buttons">

                    <span class="pull-right">
				<button class="p-button-secondary" tabindex="{{tabIndex + 1600}}" type="button" (click)="resetForm()">Clear</button>
					<button class="ml-3 {{checkValuePresent()?'p-button-disabled':'p-button-primary'}}" tabindex="{{tabIndex + 1610}}" type="submit" (click)="searchFilterData(filtersForm)" disabled="{{checkValuePresent()?'disabled':''}}">Search {{typeSearch}}</button>
			</span>

                </div>

            </div>
        </form>
        <div class="clear"></div>
    </p-panel>
</div>